import { asset } from '@/utils/basePath';
import { fundamentalsStackedLogoSrc } from './fundamentalsStackedLogo';

/**
 * 2026-10-30 — Logo de Reconocimiento Diario en la etiqueta «Recibido en» de los post-its.
 *
 * El cliente entregó el arte «Cada Día» (`logodaly-esp.svg` → `logo-cada-dia-es.svg`) SOLO en español,
 * y pidió el cambio solo en español. Los demás idiomas conservan el logo de Fundamentales que ya
 * tenían (`fundamentalsStackedLogoSrc`), hasta que haya arte en su idioma.
 *
 * Es un helper aparte, y no un cambio en `fundamentalsStackedLogoSrc`, porque ése también pinta el
 * hero de «Reconocer», que no forma parte del pedido.
 *
 * `cadaDia` avisa que el arte es el CÍRCULO de «Cada Día»: necesita más alto que el wordmark (a 18 px
 * no se lee) y no debe pasar por el filtro que vuelve blancos los logos en modo oscuro, que lo
 * convertiría en un disco blanco (`.postit-tag-logo--cada-dia` en `recognition.css`).
 */
const DIARIO_LOGO_ES = asset('/assets/logo-cada-dia-es.svg');

export function diarioPostItLogo(lang: string): { src: string; cadaDia: boolean } {
  const shortCode = lang.split('-')[0].toLowerCase();
  return shortCode === 'es'
    ? { src: DIARIO_LOGO_ES, cadaDia: true }
    : { src: fundamentalsStackedLogoSrc(lang), cadaDia: false };
}
